import React from "react";

import { cn } from "../../../lib/utils";

// components
import { InputBase, InputBaseProps } from "../InputBase";

type InputTextProps = Omit<InputBaseProps, "type" | "min" | "max" | "inputMode">;

/**
 * InputText is an Isotope of InputBase with additional props for text input.
 * It is a controlled component that uses the value and onChange props to update the input value.
 * This component is used outside of a form context. If you need a form-connected text input, use FormInputText
 */
const InputText = ({
	value,
	onChange,
	onBlur,
	disabled,
	errored,
	dangerouslySetClassName,
	id,
	"data-testid": dataTestId,
	leftIcon,
	placeholder,
	clearable,
	minLength,
	maxLength,
	spellCheck,
}: InputTextProps) => {
	return (
		<InputBase
			value={value}
			onChange={onChange}
			onBlur={onBlur}
			type="text"
			inputMode="text"
			disabled={disabled}
			errored={errored}
			dangerouslySetClassName={cn(dangerouslySetClassName)}
			leftIcon={leftIcon}
			placeholder={placeholder}
			clearable={clearable}
			id={id}
			data-testid={dataTestId}
			aria-label={`${id} text input`}
			minLength={minLength}
			maxLength={maxLength}
			spellCheck={spellCheck}
		/>
	);
};

export { InputText, type InputTextProps };
